export const DEVICE_FOR_RECEIPT_ALLOWED_COMPANIES = ['a422295', 'a900779'];

export function isDeviceForReceiptEnabled(company) {
    return DEVICE_FOR_RECEIPT_ALLOWED_COMPANIES.includes(company);
}

/** Campos incompatíveis com dispositivo somente para consulta de comprovantes. */
export const RECEIPT_CONFLICTING_FLAG_FIELDS = [
    'enable_password_punch',
    'break_device',
    'is_repa',
    'enableRepA',
    'enable_auto_update',
    'timezone_filter',
    'triple_validation',
    'enable_punches_logs',
    'enable_punch_backup',
    'enable_punch_by_manager',
    'save_photo_on_punch',
    'blink',
    'smile',
    'head_movement',
    'enable_facial_recognition_flow',
    'online_only',
    'auto_timezone',
    'only_with_location',
    'only_inside_geofence',
    'range_ip',
    'hide_password_config_access',
    'hide_reconfigure_multi',
    'hide_punch_receipt_display_time',
];

export function hasConflictingFlags(values) {
    const hasRangeIp = values.range_ip || (values.ips ?? []).some((ip) => ip?.trim?.());
    return hasRangeIp || RECEIPT_CONFLICTING_FLAG_FIELDS.some((field) => Boolean(values[field]));
}

export function getReceiptModeResetValues() {
    return {
        ...RECEIPT_CONFLICTING_FLAG_FIELDS.reduce((acc, field) => {
            acc[field] = false;
            return acc;
        }, {}),
        ips: [],
    };
}
